import { getScreenName } from '../../../Utils/helper';

import { fireEvent } from '../../../Utils/fireEvent';

export const fireClickAmazonCard = (data, fromCarousel) => {
  fireEvent({
    category: 'clicked_card_in_general_screen',
    screen_name: getScreenName(),
    section_name: fromCarousel
      ? 'Amazon Affiliate Carousel'
      : 'Amazon Affiliate Links',
    card_name: data?.text.substring(0, 99),
    deeplink_value: data?.link,
  });
};
export const fireImpressionAmazonCard = (data, count) => {
  fireEvent({
    category: 'impression_card_in_general_screen',
    screen_name: getScreenName(),
    section_name: 'Amazon Affiliate Links',
    card_name: data?.text.substring(0, 99),
    deeplink_value: data?.link,
  });
};

export const fireImpressionAmazonCarousel = () => {
  return {
    category: 'impression_section_in_general_screen',
    section_name: 'Amazon Affiliate Carousel',
  };
};
